<script setup lang="ts">
import { UserAvatar } from '#shared'
import { capitalize } from 'vue'
import { useRouter } from 'vue-router'
import type { Message } from '../model/message'
import MessageAttachments from './message-attachments.vue'
import MessageText from './message-text.vue'

const { respondFor, variant = 'regular' } = defineProps<{ respondFor: Message; variant?: 'regular' | 'compact' }>()

const router = useRouter()

const onClick = () => {
  const currentQuery = router.currentRoute.value.query

  router.replace({
    query: { ...currentQuery, targetMessageId: respondFor.id, navnonce: Date.now() },
  })
}
</script>

<template>
  <div :class="[$style.root, $style['rootVariant' + capitalize(variant)]]">
    <button :class="[$style.body, $style['bodyVariant' + capitalize(variant)]]" title="View message" @click="onClick">
      <div :class="$style.sender">
        <UserAvatar :class="$style.senderAvatar" size="tiny" :user="respondFor.sender" />
        <span :class="[$style.name, $style['nameVariant' + capitalize(variant)]]">
          {{ respondFor.sender.displayName }}
        </span>
      </div>

      <div :class="$style.content">
        <MessageAttachments :message="respondFor" :variant="variant" />

        <MessageText :message="respondFor" :variant="variant" />
      </div>
    </button>
  </div>
</template>

<style lang="scss" module>
@use '#mixins/media' as media;

.root {
  display: flex;
  gap: 10px;
  width: 100%;
}

.rootVariantRegular {
  padding-top: 10px;
}

.rootVariantCompact {
  padding-top: 10px;
}

.body {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin: -5px 0;
  padding: 5px 0;
  padding-left: 55px;

  padding-left: 10px;
  border-left: 2px solid #4a8dff60;

  &:hover {
    background-color: #397ae920;

    .content {
      opacity: 1;
    }
  }
}

.bodyVariantRegular {
  gap: 10px;
}

.bodyVariantCompact {
  gap: 5px;
}

.sender {
  display: flex;
  align-items: center;
  width: fit-content;
}

.iconVariantRegular {
  margin-right: 10px;
}

.iconVariantCompact {
  margin-right: 5px;
  transform: scale(0.8);
}

.senderAvatar {
  margin-right: 5px;
}

.nameVariantCompact {
  font-size: 14px;
}

.content {
  opacity: 0.6;
  min-width: 0;
}
</style>
